module.exports = __webpack_public_path__ + "images/root/mainVisual_bgImage_web_857a85c5fa0316662eff84380a2819f8.png";